module.exports = __webpack_public_path__ + "img/salvador-espinosa - Copy.25ecbee7.png";